import React from 'react';

import { SearchIcon } from './SearchIcon';
import { useAuth } from '../../../shared';
import { Badge } from '../../../components';
import { SettingsIcon } from './SettingsIcon';

type UserBarProps = {};

type IconButtonProps = {
  children: React.ReactNode;
};
const IconButton: React.FC<IconButtonProps> = ({ children }) => {
  return (
    <div className="size-[4rem] shrink-0 grow-0 bg-content flex items-center justify-center border border-active rounded-full cursor-pointer hover:bg-active transition-default">
      {children}
    </div>
  );
};

const UserAvatar: React.FC = () => {
  const { user } = useAuth();
  if (!user) return null;

  const { picture, nickname } = user;
  const element = picture ? (
    <img src={picture} className="w-full h-full" />
  ) : (
    <Badge shrink rounded text={nickname || ''} />
  );

  return (
    <div className="ml-lg flex flex-row items-center justify-center gap-x-sm">
      <div className="font-medium text-small">{nickname}</div>
      <div className="h-[4rem] aspect-square rounded-full overflow-hidden">
        {element}
      </div>
    </div>
  );
};

const UserBar: React.FC<UserBarProps> = () => {
  return (
    <div className="ml-auto h-[4rem] flex items-center justify-center gap-x-sm">
      <IconButton>
        <SearchIcon />
      </IconButton>
      <IconButton>
        <SettingsIcon />
      </IconButton>
      <UserAvatar />
    </div>
  );
};

export default React.memo(UserBar) as typeof UserBar;
